export const zIndex = {
  FLOATING_MENU: 2,
  FLOATING_LOGO: 2
};
